import { render, staticRenderFns } from "./picturecard_one.vue?vue&type=template&id=10b4ee6e&scoped=true&"
import script from "./picturecard_one.vue?vue&type=script&lang=js&"
export * from "./picturecard_one.vue?vue&type=script&lang=js&"
import style0 from "./picturecard_one.vue?vue&type=style&index=0&id=10b4ee6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4ee6e",
  null
  
)

export default component.exports